import { deleteRequest, get, post } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        is_submitting: false,
        member_list_data: {
            totalHits: 0,
            memberList: []
        },
        member_data: {
            id: "",
            details: [],
            memberName: "", 
            memberRoles: [],
            memberImgSrc: "", 
            memberProfileText: "",
            memberImgAlt: "", 
            answerLink: ""
        },
        member_group_id: 100,
        selected_member_id: 2828,
        active_member_id: 8282,
        active_group_id: 300,
        direct_messages_bootstrapped: false,
        direct_message_thread_id: "",
        direct_message_thread_loading_id: "",
        direct_message_thread_data: [],
        direct_message_threads: [],
        direct_message_threads_data: {},
        direct_message_threads_take: 25,
        set_add_users_data: [],
        new_chat_users: [],
        show_user_search: false,
        theme_statistics: {},
        group_statistics: {},
        post_statistics: {},
        post_latest_comment: {},
        post_comments: {},
    },
    mutations: {
        set_member_list_data(state,memberListData){
            state.member_list_data = memberListData
        },
        set_member_data(state,memberData){
            state.member_data = memberData
        },
        set_is_submitting(state,boolean){
            state.is_submitting = boolean
        },
        set_direct_messages_bootstrapped(state, value) {
            state.direct_messages_bootstrapped = value
        },
        set_direct_message_thread_id(state, chatId) {
            state.direct_message_thread_id = chatId
        },
        set_direct_message_thread_loading_id(state, chatId) {
            state.direct_message_thread_loading_id = chatId
        },
        set_direct_message_thread_data(state, data) {
            state.direct_message_thread_data = data
        },
        set_direct_message_threads(state, threads) {
            state.direct_message_threads = [...state.direct_message_threads, ...threads]        
        },
        reset_direct_message_threads(state, threads) {
            state.direct_message_threads = threads           
        },
        set_direct_message_threads_data(state, data) {
            state.direct_message_threads_data = data
        },
        set_direct_message_threads_take(state, take) {
            state.direct_message_threads_take = take
        },
        set_add_users_data(state, data) {
            state.add_users_data = data
        },
        set_theme_statistics(state, data) {
            state.theme_statistics[data.themeId] = data.statistics
        },
        set_group_statistics(state, data) {
            state.group_statistics[data.groupId] = data.statistics
        },
        set_post_statistics(state, data) {
            state.post_statistics[data.postId] = data.statistics
        },
        set_post_latest_comment(state, data) {
            state.post_latest_comment[data.postId] = data.latest_comment
        },
        set_post_comments(state, data) {
            state.post_comments[data.postId] = data.comments
        },
        set_new_chat_users(state, data) {
            state.new_chat_users = data
        },
        set_show_user_search(state, data) {
            state.show_user_search = data
        },
    },
    actions: {
        async getGroupStatistics(context, config) {
            const url = `${document.location.origin}/${process.env.GET_GROUP_STATISTICS.replace("[groupId]", config.groupId)}`
            const response = await get(url)

            context.commit('set_group_statistics', {
                statistics: response,
                groupId: config.groupId
            })
        },
        async getThemeStatistics(context, config) {
            const url = `${document.location.origin}/${process.env.GET_THEME_STATISTICS.replace("[themeId]", config.themeId)}`
            const response = await get(url)

            context.commit('set_theme_statistics', {
                statistics: response,
                themeId: config.themeId
            })
        },
        async getPostStatistics(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_GET_POST_STATISTICS.replace("[postId]", config.postId)}`
            const response = await get(url)

            context.commit('set_post_statistics', {
                statistics: response,
                postId: config.postId
            })
        },
        async getPostLatestComment(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_GET_POST_LATEST_COMMENT.replace("[postId]", config.postId)}`
            const response = await get(url)

            context.commit('set_post_latest_comment', {
                latest_comment: response,
                postId: config.postId
            })
        },
        async getPostComments(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_GET_POST_COMMENTS.replace("[postId]", config.postId).replace("[pageId]", config.pageId)}`
            const response = await get(url)

            context.commit('set_post_comments', {
                comments: response,
                postId: config.postId
            })
        },
        async getMemberListData(context, config){
            context.commit("set_is_submitting", true)

            const url = `${document.location.origin}/` +
            `${process.env.FORUM_MEMBER_LIST_DATA.replace("[groupid]", config.id)}` +
            `?skip=${config.skip}&take=${config.take}`

            const response = await get(url)

            if (config.skip === 0) {
                context.commit('set_member_list_data', response)
            } else {
                context.commit(
                    'set_member_list_data',
                    {
                        ...response,
                        memberList: context.state.member_list_data.memberList?.concat(response.memberList)
                    }
                )
            }
            context.commit("set_is_submitting", false)
        },
        async getMemberData(context, config){
            context.commit("set_is_submitting", true)

            const url = `${document.location.origin}/${process.env.FORUM_MEMBER_DATA.replace("[id]", config.userId)}`
            const response = await get(url)
            context.commit('set_member_data', response)

            context.commit("set_is_submitting", false)
        },
        async getDirectMessageThreads(context,  config) {
            context.commit("set_is_submitting", true)
            if (!config.userId) return  

            const url = `${document.location.origin}/` +
            `${process.env.COMMUNITY_GET_USER_CHATS}`.replace("[userId]", config.userId) +
            `?skip=${config.skip}&take=${config.take}`

            const response = await get(url)
            const hits = response?.hits ?? []
            if (config.skip === 0) {
                context.commit('reset_direct_message_threads', hits)
            } else {
                context.commit('set_direct_message_threads', hits)
            }
            context.commit('set_direct_message_threads_data', {totalHits: response?.totalHits ?? 0})

            if(config.toProfileId) {
                const url = `${document.location.origin}/${process.env.FORUM_MEMBER_DATA}`.replace("[id]", config.toProfileId)
                const response = await get(url)
                context.commit("set_new_chat_users", [response])
            } else if (hits.length > 0 && config.loadFirstChat) {   
                context.dispatch('clearDirectMessageThread')
                context.dispatch('getDirectMessageThreadData', { 
                    chatId: config.chatId ?? response.hits[0].id 
                })
            }          
        
            context.commit("set_is_submitting", false)
        },
        async refreshDirectMessageThreads(context,  config) {
            context.commit("set_is_submitting", true)

            const url = `${document.location.origin}/` +
            `${process.env.COMMUNITY_GET_USER_CHATS}`.replace("[userId]", config.userId) +
            `?skip=${0}&take=${context.state.direct_message_threads_take}`

            const response = await get(url)
            context.commit('reset_direct_message_threads', response.hits)    
            context.commit('set_direct_message_threads_data', {totalHits: response.totalHits})        
            context.commit("set_is_submitting", false)
        },
        async submitSavePost(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_SAVE_POST.replace("[postId]", config.id)}`
            const body = JSON.stringify(config.save)
            return await post(url, body)    
        },
        async submitNewComment(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_CREATE_COMMENT.replace("[postId]", config.id)}`
            const response =  await post(url, config.body, null, true)
            return response
        },
        async submitNewSubComment(context, config) {
            context.commit("set_is_submitting", true)
            const url = `${document.location.origin}/${process.env.COMMUNITY_CREATE_SUBCOMMENT.replace("[commentId]", config.id)}`
            const response =  await post(url, config.body, null, true)
            context.commit("set_is_submitting", false)
            return response
        },
        async submitDeleteComment(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_DELETE_COMMENT.replace("[commentId]", config.id)}`
            const response = await post(url)
            return response
        },
        async submitEditComment(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_EDIT_COMMENT.replace("[commentId]", config.id)}`
            const response = await post(url, config.body, null, true)
            
            if (response.success) {
                location.reload()
            }
            return response
        },
        async submitMemberApplication(context, config) {
            const baseUrl = document.location.origin;
            const applicationUrl = process.env.SUBMIT_FORUM_MEMBER_APPLICATION
                .replace("[id]", context.state.active_member_id)
                .replace("[groupid]", config.id);

            const url = `${baseUrl}/${applicationUrl}`;
            const body = `"${btoa(unescape(encodeURIComponent(config.body.content)))}"`
            return await post(url, body)
        },
        async removeForumProfilePicture(context, config) {
            const url = `${document.location.origin}/${process.env.FORUM_PROFILE_PICTURE.replace("[id]", config.id)}`
            return await deleteRequest(url, null, null, true)
        },
        async submitForumProfilePicture(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_FORUM_PROFILE_PICTURE.replace("[id]", config.id)}`
            const body = config.formData
            return await post(url, body, null, true)
        },
        async submitCreatePost(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_CREATE_POST.replace("[postId]", config.id)}`
            return await post(url, config.body, null, true)
        },
        async submitEditPost(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_EDIT_POST.replace("[postId]", config.postId)}`
            return await post(url, config.body, null, true)
        },
        async deletePost(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_DELETE_POST.replace("[postId]", config.id)}`
            const body = ""
            const response = await deleteRequest(url, body)
            if (response.continueUrl) {                
                window.location.href = response.continueUrl
            }
            return response
        },
        async submitCreateGallery(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_CREATE_GALLERY.replace("[id]", config.id)}`
            const body = JSON.stringify(config.body)
            return await post(url, body)
        },
        async submitSaveProfile(context, config) {
            context.commit("set_is_submitting", true)

            const url = `${document.location.origin}/${process.env.FORUM_SUBMIT_EDIT_PROFILE}`
            const body = JSON.stringify(config.body)
            const response = await post(url, body)

            context.commit("set_is_submitting", false)
            return response
        },
        async submitEditGallery(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_EDIT_GALLERY.replace("[id]", config.id)}`
            const body = JSON.stringify(config.body)
            return await post(url, body)
        },
        async getDirectMessageThreadData(context, config) {
            if (context.state.direct_message_thread_loading_id === config.chatId) return
            context.commit("set_direct_message_thread_loading_id", config.chatId)
            context.commit("set_is_submitting", true)

            const url = `${document.location.origin}/${process.env.COMMUNITY_GET_CHAT.replace("[chatId]", config.chatId)}`
            context.commit("set_direct_message_thread_id", config.chatId)
            const response = await get(url)
            context.commit('set_direct_message_thread_data', response)

            context.commit("set_direct_message_thread_loading_id", "")
            context.commit("set_is_submitting", false)
        },
        async submitDirectMessageThreadComment(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_CREATE_DIRECT_MESSAGE.replace("[chatId]", config.chatId)}`

            const formData = new FormData()
            formData.append('text', config.text)

            config.files.forEach(file => {
                formData.append('filesToAdd', file)
            })

            const response = await post(url, formData, null, true)

            var threadDataPromise = context.dispatch('getDirectMessageThreadData', { chatId: config.chatId })
            var messageThreadsPromise = context.dispatch('refreshDirectMessageThreads', { userId: config.userId })
            await Promise.all([threadDataPromise, messageThreadsPromise])

            return response
        },
        async editDirectMessageThreadComment(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_EDIT_DIRECT_MESSAGE.replace("[commentId]", config.commentId).replace("[chatId]", config.chatId)}`
            const response = await post(url, config.body, null, true)
            context.dispatch('getDirectMessageThreadData', { chatId: config.chatId })
            context.dispatch('refreshDirectMessageThreads', { userId: config.userId })
            return response
        },
        async deleteDirectMessageThreadComment(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_DELETE_DIRECT_MESSAGE.replace("[commentId]", config.commentId).replace("[chatId]", config.chatId)}`
            const response = await post(url, null, null, null, null, true)
            context.dispatch('getDirectMessageThreadData', { chatId: config.chatId })
            context.dispatch('refreshDirectMessageThreads', { userId: config.userId })
            return response
        },
        async deleteDirectMessageThread(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_DELETE_CHAT.replace("[chatId]", config.chatId)}`
            const response = await post(url, null, null, null, null, true)
            context.commit('set_direct_message_thread_id', '')
            return response
        },
        async searchForUser(context, config) {
            if (config.query !== "") {
                const url = `${document.location.origin}/${process.env.COMMUNITY_CHAT_SEARCH_USERS}`.replace('[query]', config.query).replace('[take]', config.take)
                const response = await get(url)
                context.commit('set_add_users_data', response.hits)
                return response
            }
        },
        clearSearchForUser(context) {
            context.commit('set_add_users_data', [])
        },
        async createNewDirectMessageThread(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_CREATE_CHAT}`

            const formData = new FormData()
            config.userIds.forEach((value, index) => {
                formData.append(`userIds[${index}]`, value);
              });
            formData.append("message", config.message)
            
            config.files.forEach(file => {
                formData.append('files', file)
            })

            const response = await post(url, formData, null, true)

            context.dispatch('clearDirectMessageThread')
            
            var threadDataPromise = context.dispatch('getDirectMessageThreadData', { chatId: response.chatId })
            var messageThreadsPromise = context.dispatch('refreshDirectMessageThreads', { userId: config.userId })
            await Promise.all([threadDataPromise, messageThreadsPromise])
        },
        async findChatWithUser(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_FIND_CHAT_WITH_USER}?profileId=${config.profileId}`
            const response = await get(url)
            return response?.chatId ?? null
        },
        async setupNewChatRecipient(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_GET_CHAT_MEMBER_PROFILE}?profileId=${config.profileId}`
            const response = await get(url)
            if (response && !response.hasError && response.id) {
                context.commit('set_new_chat_users', [response])
            }
        },
        clearDirectMessageThread(context) {
            context.commit('set_add_users_data', [])
            context.commit("set_show_user_search", false)
            context.commit("set_new_chat_users", [])

            context.commit('set_direct_message_thread_id', "")
            context.commit('set_direct_message_thread_loading_id', "")
            context.commit('set_direct_message_thread_data', {
                chat: [],
                chatIcon:"",
                chatName: "",
                id: ""
            })
        },
        async leaveGroup(context, config) {
            const url = `${document.location.origin}/${process.env.COMMUNITY_LEAVE_GROUP.replace("[groupId]", config.groupId)}`
            const callback = (json) => { 
                console.log("callback", json)
                window.location.href = json.returnUrl }
            return await post(url, null, callback)
        },
        async rejectNotification(context, config) {
            const url = `${document.location.origin}/${process.env.REJECT_NOTIFICATION.replace("[id]", config.notificationId)}`
            const body = JSON.stringify(config.body)
            return await post(url, body, config.callback)
        },
        async approveNotification(context, config) {
            const url = `${document.location.origin}/${process.env.APPROVE_NOTIFICATION.replace("[id]", config.notificationId)}`
            const body = JSON.stringify(config.body)
            return await post(url, body, config.callback)
        },
        async rejectGruppeadgangsanmodning(context, config) {
            const url = `${document.location.origin}/${process.env.REJECT_GRUPPEADGANGSANMODNING.replace("[id]", config.gruppeadgangsanmodningId)}`
            const body = JSON.stringify(config.body)
            return await post(url, body, config.callback)
        },
        async approveGruppeadgangsanmodning(context, config) {
            const url = `${document.location.origin}/${process.env.APPROVE_GRUPPEADGANGSANMODNING.replace("[id]", config.gruppeadgangsanmodningId)}`
            const body = JSON.stringify(config.body)
            return await post(url, body, config.callback)
        },
        async createCancerForumProfile(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_CREATE_FORUM_PROFILE}`
            const body = JSON.stringify(config.body)
            const response = await post(url, body, null, null, config.pageId)
            if (response.continueUrl) {
                window.location.href = response.continueUrl
            }
            return response
        },
        async deleteCancerProfile(context, config) {
            const url = `${document.location.origin}/${process.env.DELETE_CANCER_PROFILE.replace("[id]", config.id)}`
            const response = await deleteRequest(url)
            if (response.success) {
                window.location.href = response.continueUrl
            }
            return response
        },
        async deleteCancerProfileAndData(context, config) {
            const url = `${document.location.origin}/${process.env.DELETE_CANCER_PROFILE_AND_DATA.replace("[id]", config.id)}`
            const response = await deleteRequest(url)
            if (response.success) {
                window.location.href = response.continueUrl
            }
            return response
        },
        async createEvent(context, config) {
            const url = `${document.location.origin}/${process.env.CREATE_EVENT}`
            const body = JSON.stringify(config.body)
            const response = await post(url, body)
            if (response.success) {
                window.location.href = response.continueUrl
            }
            return response
        },
        async editEvent(context, config) {
            const url = `${document.location.origin}/${process.env.EVENT_EDIT.replace("[id]", config.id)}`
            const body = JSON.stringify(config.body)
            const response = await post(url, body)
            if (response.success) {
                window.location.href = response.continueUrl
            }
            return response
        },
        async deleteEvent(context, config) {
            const url = `${document.location.origin}/${process.env.DELETE_EVENT.replace("[id]", config.id)}`
            const response = await post(url, null)
            return response
        },
        async editFrivilligeProfile(context, config) {
            const url = `${document.location.origin}/${process.env.EDIT_FRIVILLIG_PROFILE.replace("[id]", config.id)}`
            const body = JSON.stringify(config.body)
            return await post(url, body)
        }
    },
}
